import * as Sentry from "@sentry/vue";
export function useSentryUsers() {
  function setUser(user) {
    if (!Sentry.setUser)
      return;
    Sentry.setUser(user);
  }
  function revokeUser() {
    Sentry.configureScope((scope) => scope.setUser(null));
  }
  return {
    setUser,
    revokeUser
  };
}
